import React from "react";
import {
  MessageActions,
  defaultMessageActionSet,
  QuickMessageActionsButton,
  IconReply,
  useMessageContext,
  useMessageComposerController,
} from "stream-chat-react";

// Arrow button beside a message (before the 3 dots): Quote Reply.
// In the Stream kit this arrow opens a thread; here it quotes the message in the message box.
const QuickQuoteReply = () => {
  const { message } = useMessageContext();
  const messageComposer = useMessageComposerController();

  const handleQuote = () => {
    messageComposer.setQuotedMessage(message);

    // Same as the kit's own "Quote Reply": put the cursor in the message box
    const textareas = message.parent_id
      ? document.querySelectorAll(
          ".str-chat__thread .str-chat__textarea__textarea"
        )
      : document.getElementsByClassName("str-chat__textarea__textarea");
    const textarea = textareas.item(0);

    if (textarea instanceof HTMLTextAreaElement) {
      textarea.focus();
    }
  };

  return (
    <QuickMessageActionsButton
      aria-label="Quote Reply"
      title="Quote Reply"
      data-testid="quick-quote-reply-action"
      onClick={handleQuote}
    >
      <IconReply className="str-chat__message-action-icon" />
    </QuickMessageActionsButton>
  );
};

// Options taken out of the 3 dots menu of a message.
// To bring an option back, comment its line here.
const HIDDEN_MENU_ACTIONS = [
  "reply", // Thread Reply
  "mute", // Mute
  "blockUser", // Block User
];

// Message actions (the icons beside a message and the 3 dots menu).
//
//   1. the options of HIDDEN_MENU_ACTIONS are taken out of the 3 dots menu
//   2. the arrow does Quote Reply instead of opening a thread
//
// To get the kit's own list back (everything, with Thread Reply on the arrow):
//   const STAFF_MESSAGE_ACTION_SET = defaultMessageActionSet;
const STAFF_MESSAGE_ACTION_SET = defaultMessageActionSet
  // 1. 3 dots menu
  .filter(
    (action) =>
      !(
        action.placement === "dropdown" &&
        HIDDEN_MENU_ACTIONS.includes(action.type)
      )
  )
  // 2. { placement: "quick", type: "reply" } = the arrow
  .map((action) =>
    action.type === "reply" && action.placement === "quick"
      ? { Component: QuickQuoteReply, placement: "quick", type: "quote" }
      : action
  );

const StaffMessageActions = () => (
  <MessageActions messageActionSet={STAFF_MESSAGE_ACTION_SET} />
);

export default StaffMessageActions;
